import createIcon from '../../createIcon';

/**
 * @component @name PlayLesson
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcgMTAuNUMxNy4zNCAxMC41IDE3LjY3IDEwLjUzIDE4IDEwLjU4VjMuNUMxOCAyLjQgMTcuMSAxLjUgMTYgMS41SDRDMi45IDEuNSAyIDIuNCAyIDMuNVYxOS41QzIgMjAuNiAyLjkgMjEuNSA0IDIxLjVIMTEuMjZDMTAuNDcgMjAuMzcgMTAgMTguOTkgMTAgMTcuNUMxMCAxMy42MyAxMy4xMyAxMC41IDE3IDEwLjVaTTYgMTAuNVYzLjVIMTFWMTAuNUw4LjUgOUw2IDEwLjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTcgMTIuNUMxNC4yNCAxMi41IDEyIDE0Ljc0IDEyIDE3LjVDMTIgMjAuMjYgMTQuMjQgMjIuNSAxNyAyMi41QzE5Ljc2IDIyLjUgMjIgMjAuMjYgMjIgMTcuNUMyMiAxNC43NCAxOS43NiAxMi41IDE3IDEyLjVaTTE1Ljc1IDIwVjE1TDE5Ljc1IDE3LjVMMTUuNzUgMjBaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PlayLesson = createIcon('PlayLesson', [
  [
    'path',
    {
      d: 'M17 10.5C17.34 10.5 17.67 10.53 18 10.58V3.5C18 2.4 17.1 1.5 16 1.5H4C2.9 1.5 2 2.4 2 3.5V19.5C2 20.6 2.9 21.5 4 21.5H11.26C10.47 20.37 10 18.99 10 17.5C10 13.63 13.13 10.5 17 10.5ZM6 10.5V3.5H11V10.5L8.5 9L6 10.5Z',
      key: 'tw3sr8',
    },
  ],
  [
    'path',
    {
      d: 'M17 12.5C14.24 12.5 12 14.74 12 17.5C12 20.26 14.24 22.5 17 22.5C19.76 22.5 22 20.26 22 17.5C22 14.74 19.76 12.5 17 12.5ZM15.75 20V15L19.75 17.5L15.75 20Z',
      key: 't3u4c1',
    },
  ],
]);

export default PlayLesson;
